exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--modal{top:100px!important;left:410px!important;width:600px!important;height:500px!important}@media screen and (max-width:500px){.vm--modal{height:100vh!important;top:0!important;left:0!important;width:100vw!important}}", ""]);

// exports
